import React, { useCallback, useContext, useMemo } from "react";
import { Form, Formik } from "formik";
import FormWarningsContext from "contexts/FormWarningsContext";
import { Col, Row } from "components/bootstrap";
import { FormSubmit } from "components/common";
import FormWarningsProvider from "contexts/FormWarningsProvider";
import validateSearchFilterForm from "search-filter/validateForm";
import TitleFormGroup from "search-filter/components/form-elements/TitleFormGroup";
import DescriptionFormGroup from "search-filter/components/form-elements/DescriptionFormGroup";
import useUserDateTime from "hooks/useUserDateTime";
import PluggableStoreProvider from "views/stores/ViewsStoreProvider";
import View from "views/logic/views/View";
import SearchExecutionState from "views/logic/search/SearchExecutionState";
import Search from "views/logic/search/Search";
import useHistory from "routing/useHistory";
import EntityCreateShareFormGroup from "components/permissions/EntityCreateShareFormGroup";
import SearchFiltersRoutes from "search-filter/Routes";
import QueryStringFormGroup from "../form-elements/QueryStringFromGroup";
const PseudoStoreProvider = ({ children = void 0 }) => {
  const view = useMemo(() => View.builder().search(Search.create()).build(), []);
  const executionState = useMemo(() => SearchExecutionState.empty(), []);
  return /* @__PURE__ */ React.createElement(PluggableStoreProvider, { view, isNew: true, initialQuery: "none", executionState }, children);
};
const UserSearchFilterForm = ({
  children = void 0,
  initialValues = {},
  action = "create",
  submitButtonText = "Save",
  submitLoadingText = "Saving...",
  onSubmit,
  disableSubmitButton = false
}) => {
  const { setFieldWarning } = useContext(FormWarningsContext);
  const { userTimezone } = useUserDateTime();
  const history = useHistory();
  const handleCancel = useCallback(() => history.push(SearchFiltersRoutes.LIST), [history]);
  const validate = useCallback(
    (values) => validateSearchFilterForm(values, { setFieldWarning, userTimezone }),
    [userTimezone, setFieldWarning]
  );
  return /* @__PURE__ */ React.createElement(Formik, { onSubmit, validateOnMount: true, validate, initialValues }, ({ isValid, isSubmitting, values, setFieldValue }) => {
    const disableSubmit = disableSubmitButton || !isValid || !values.queryString;
    return /* @__PURE__ */ React.createElement(Form, { className: "form form-horizontal" }, /* @__PURE__ */ React.createElement(PseudoStoreProvider, null, /* @__PURE__ */ React.createElement(QueryStringFormGroup, null)), /* @__PURE__ */ React.createElement(TitleFormGroup, null), /* @__PURE__ */ React.createElement(DescriptionFormGroup, null), children, action === "create" && /* @__PURE__ */ React.createElement(Row, null, /* @__PURE__ */ React.createElement(Col, { md: 9, mdOffset: 3 }, /* @__PURE__ */ React.createElement(
      EntityCreateShareFormGroup,
      {
        description: "Search for a User or Team to add as collaborator on this filter.",
        entityType: "search_filter",
        entityTitle: "",
        onSetEntityShare: (payload) => setFieldValue("share_request", payload)
      }
    ))), /* @__PURE__ */ React.createElement(Row, null, /* @__PURE__ */ React.createElement(Col, { md: 9, mdOffset: 3 }, /* @__PURE__ */ React.createElement(
      FormSubmit,
      {
        submitButtonText,
        disabledSubmit: disableSubmit,
        submitLoadingText,
        isSubmitting,
        isAsyncSubmit: true,
        onCancel: handleCancel
      }
    ))));
  });
};
const UserSearchFilterFormWrapper = ({ ...props }) => /* @__PURE__ */ React.createElement(FormWarningsProvider, null, /* @__PURE__ */ React.createElement(UserSearchFilterForm, { ...props }));
export default UserSearchFilterFormWrapper;
